import React from 'react';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Icon from '../../../Icon';

export const WalkthroughImages = ({ propertyWalkThroughFormData, showAttachments }) =>

    propertyWalkThroughFormData.configTypeSaved && propertyWalkThroughFormData.configTypeSaved.walkThroughMedia && propertyWalkThroughFormData.configTypeSaved.walkThroughMedia.length > 0 ?
     <Carousel autoPlay showThumbs={false} showStatus={false} showIndicators={false}>
        {
            propertyWalkThroughFormData.configTypeSaved && propertyWalkThroughFormData.configTypeSaved.walkThroughMedia && propertyWalkThroughFormData.configTypeSaved.walkThroughMedia.length > 0 ?
                propertyWalkThroughFormData.configTypeSaved.walkThroughMedia.map((item, i) => {
                    if (item.type === "Embed") {
                        return (<div dangerouslySetInnerHTML={{ __html: `${item.url} ` }} />)
                    } else {
                            return (
                                <div style={{ backgroundColor: '#fff' }} onClick={() => showAttachments(i)}>

                                    <img alt="" src={item.url} />

                                </div>
                            )
                    }

                }
                ) : null}
    </Carousel>
        :
        <div className="viewAllAreasAndFloorPlan__emptyImages">
            <Icon
                size='large'
                weight="light"
                glyph="image"
            />
            <div>
                {'There is currently no additional media available for this walk through.'}
            </div>
        </div>

